import { render, staticRenderFns } from "./AddInquiryModule.vue?vue&type=template&id=1408cac0&scoped=true&"
import script from "./AddInquiryModule.vue?vue&type=script&lang=js&"
export * from "./AddInquiryModule.vue?vue&type=script&lang=js&"
import style0 from "./AddInquiryModule.vue?vue&type=style&index=0&id=1408cac0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408cac0",
  null
  
)

export default component.exports